angular.module('lsnBase.models')
.factory('LsnEstateModelConstants', [function() {
    var EstateModelConstants = {};

    // słownik stworzony przez nas
    EstateModelConstants.ESTATE_TYPE_FLAT = 'flat';
    EstateModelConstants.ESTATE_TYPE_HOUSE = 'house';
    EstateModelConstants.ESTATE_TYPE_GARAGE = 'garage';
    EstateModelConstants.ESTATE_TYPE_OUTBUILDING = 'outbuilding';
    EstateModelConstants.ESTATE_TYPE_HOUSE_UNDER_CONSTRUCTION = 'construction';
    EstateModelConstants.ESTATE_TYPE_SUMMER_HOUSE = 'summerHouse';
    // słownik typów lokalizacji
    EstateModelConstants.DICTIONARY_ESTATE_TYPE = {};
    EstateModelConstants.DICTIONARY_ESTATE_TYPE[EstateModelConstants.ESTATE_TYPE_FLAT] = 'lokal';
    EstateModelConstants.DICTIONARY_ESTATE_TYPE[EstateModelConstants.ESTATE_TYPE_HOUSE] = 'budynek';
    EstateModelConstants.DICTIONARY_ESTATE_TYPE[EstateModelConstants.ESTATE_TYPE_HOUSE_UNDER_CONSTRUCTION] = 'dom w budowie';
    EstateModelConstants.DICTIONARY_ESTATE_TYPE[EstateModelConstants.ESTATE_TYPE_SUMMER_HOUSE] = 'domek letniskowy';
    EstateModelConstants.DICTIONARY_ESTATE_TYPE[EstateModelConstants.ESTATE_TYPE_GARAGE] = 'garaż';
    EstateModelConstants.DICTIONARY_ESTATE_TYPE[EstateModelConstants.ESTATE_TYPE_OUTBUILDING] = 'budynek gospodarczy';

    return EstateModelConstants;
  }]);